import { useMutation } from 'react-query'

import { api } from '../../../api'
import { type AssetPersistence } from '../../../../types/persistence/asset-persistence'

const updateAsset = (id: number, data: AssetPersistence) => {
  return api.put(`/assets/${id}`, data)
}

export const useAssetEditMutation = () => {
  return useMutation(
    'edit-asset',
    ({ id, data }: { id: number, data: AssetPersistence }) =>
      updateAsset(id, data)
  )
}
